module.exports = __webpack_public_path__ + "media/images/icons/message-309a4d82c39bfb0eb63530769e2caaf2.svg";